// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import { getUrlParam, getUrlParamsObj } from '../route';
import { validate } from './validators';

const constraintsByType = {
  TVE: {
    required: [
      'redirect_uri',
      'client_id',
      'response_type',
      'scope',
      'requestor',
    ],

  },
  OAUTH: {
    required: [
      'redirect_uri',
      'client_id',
      'response_type',
      'scope',
    ],
  },
  ZENDESK: {
  },
  CANNY: {
    required: [
      'redirect',
      'companyID',
    ],
  },
};

export const validateUrlParams = (): boolean => {
  const formType = getUrlParam('form_type');
  if (!formType) {
    return false;
  }
  const constraints = constraintsByType[formType];
  if (!constraints) {
    return false;
  }
  const params = getUrlParamsObj();
  return validate(params, constraints);
};
